import { render } from "./Banner.vue?vue&type=template&id=14128d13&scoped=true"
const script = {}

import "./Banner.vue?vue&type=style&index=0&id=14128d13&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14128d13"

export default script